import classNames from 'classnames';
import Carousel from 'nuka-carousel';

import { RefObject, useRef, useState, useEffect } from 'react';

import { useIntl } from 'react-intl';

import { useDispatch, useSelector } from 'react-redux';

import { Modal, ModalTransition, useModal } from 'react-simple-hook-modal';

import { ReactComponent as IconCheck } from '../../../../assets/images/check.svg';
import { ReactComponent as SliderLeft } from '../../../../assets/images/circle_paging_left.svg';
import { ReactComponent as SliderRight } from '../../../../assets/images/circle_paging_right.svg';
import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import { ReactComponent as IconDownload } from '../../../../assets/images/download.svg';
import { ReactComponent as IconPicture } from '../../../../assets/images/picture.svg';
import { dataProductFull, getSujetcheckImages, uploadSujetcheckImage } from '../../../../store/location';
import { sujetcheckAssetData, sujetcheckImages } from '../../../../store/location/selectors';
import { AppState } from '../../../../store/store';
import { loadersByName, errors as errorList, togglePopup } from '../../../../store/ui';
import { popupByName } from '../../../../store/ui';
import pushToDataLayer from '../../../../utils/pushToDataLayer';
import './index.scss';
import Button, { ButtonKind } from '../button/Button';
import SpinnerV2 from '../SpinnerV2';

const SujetCheckPopupModal = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { opened: isOpenModal, payload, onClose } = useSelector(popupByName('sujet_upload_and_check'));
    const { isModalOpen, openModal, closeModal } = useModal();
    const [step, setStep] = useState<number>(0);
    const [file, setFile] = useState<File>();
    const [errors, setErrors] = useState<string[]>([]);
    // Selector für die Fehler (wichtiger Punkt)
    const sujetcheckError = useSelector((state: AppState) => errorList(state)?.['sujetcheck']);
    const isLoading = useSelector(loadersByName('sujetcheck'));
    const assetData = useSelector(sujetcheckAssetData);
    const productImages = useSelector(sujetcheckImages);
    const inputFileRef = useRef<RefObject<HTMLInputElement>>();

    const productData: any =
        payload && Array.isArray(payload) ? payload.find((item: any) => item.sujetcheckinformation !== undefined) : null;
    const sujetcheckInfo = productData?.sujetcheckinformation;

    const producturns = Array.isArray(payload)
        ? payload.map((item: any) => item.producturn).filter((urn: string | null) => urn)
        : [];

    useEffect(() => {
        if (sujetcheckError) {
            handleClose();
        }
        if (isOpenModal) {
            openModal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sujetcheckError, isOpenModal, openModal]); // Keine handleClose-Abhängigkeit

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            if (sujetcheckInfo) {
                const data = new FormData();
                data.append('orderfile', e.target.files[0] as File);
                data.append('format', sujetcheckInfo['format'] as string);

                dispatch(uploadSujetcheckImage(data));
            }
        }
    };
    const onFileUpload = () => {
        if (inputFileRef && inputFileRef.current) {
            (inputFileRef?.current as unknown as HTMLElement)?.click();
        }
    };

    const handleClose = () => {
        setFile(undefined);
        setStep(0);
        closeModal();
        dispatch(togglePopup({ name: 'sujet_upload_and_check', status: false }));
    };

    const handleGetImages = () => {
        if (sujetcheckInfo) {
            const data = new FormData();
            data.append('orderfile', file as File);
            data.append('format', sujetcheckInfo['format'] as string);

            dispatch(
                getSujetcheckImages({
                    producturns: producturns,
                    assets: [assetData.assetid],
                    bookingyear: new Date().getFullYear() as unknown as string,
                })
            );
            setStep(step + 1);
        } else {
            const newErrors = [...errors];
            const newErrorMessage = 'Sujetcheck für keines der enthaltenen Produkte möglich';
            if (!newErrors.includes(newErrorMessage)) {
                newErrors.push(newErrorMessage);
            }
            setErrors(newErrors);
        }
    };

    const getStep = (step: number) => {
        if (isLoading) {
            return (
                <div className={'modal-body d-flex flex-column justify-content-center align-items-center'}>
                    <SpinnerV2 fullScreen={false} relative={true} />
                </div>
            );
        }

        switch (step) {
            case 0:
                return (
                    <div className={'modal-body d-flex flex-column justify-content-center align-items-center'}>
                        <div className={'infotext-header'} style={{ width: '100%' }}>
                            <span>
                                {intl.formatMessage({
                                    id: 'sujetCheck.filesInfo',
                                    defaultMessage: 'Dateigrösse:',
                                })}
                            </span>
                            &nbsp;
                            <span className={'files-info'}>
                                {intl.formatMessage(
                                    {
                                        id: 'sujetCheck.filesInfoMaxSize',
                                        defaultMessage: 'max. {size} MB',
                                    },
                                    {
                                        size: sujetcheckInfo ? (
                                            <span className={'font-weight-bold'}>{sujetcheckInfo['maxsize'] as number}</span>
                                        ) : (
                                            <b>3</b>
                                        ),
                                    }
                                )}
                            </span>
                            ,&nbsp;
                            <span>
                                {intl.formatMessage({
                                    id: 'sujetCheck.filesInfoFormat',
                                    defaultMessage: 'Dateiformate:',
                                })}
                            </span>
                            &nbsp;
                            <span className={'files-info'}>
                                <b>JPG, PNG</b>
                            </span>
                        </div>
                        <div
                            className={classNames('upload-container', {
                                'upload-container--uploaded': !!file,
                            })}
                            onClick={onFileUpload}
                        >
                            <input
                                type="file"
                                ref={inputFileRef as unknown as RefObject<HTMLInputElement>}
                                onChangeCapture={onFileChangeCapture}
                                style={{ display: 'none' }}
                            />
                            {!file ? (
                                <>
                                    <IconPicture />
                                    <div className={'mt-3'}>
                                        {intl.formatMessage(
                                            {
                                                id: 'sujetCheck.format',
                                                defaultMessage: 'Format: {format}',
                                            },
                                            { format: sujetcheckInfo ? (sujetcheckInfo['format'] as string) : '' }
                                        )}
                                    </div>
                                    <h3 className={'text-primary'}>
                                        {intl.formatMessage({
                                            id: 'sujetCheck.uploadFileTitle',
                                            defaultMessage: 'Bild hinzufügen',
                                        })}
                                    </h3>
                                    <p className={'small-text'}>
                                        {intl.formatMessage({
                                            id: 'sujetCheck.uploadFileHelpText',
                                            defaultMessage: 'Eine Datei von Ihrem Computer auswählen und uploaden',
                                        })}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <IconCheck />
                                    <div className={'mt-3'}>
                                        {intl.formatMessage(
                                            {
                                                id: 'sujetCheck.format',
                                                defaultMessage: 'Format: {format}',
                                            },
                                            { format: sujetcheckInfo ? (sujetcheckInfo['format'] as string) : '' }
                                        )}
                                    </div>
                                    <h3 className={'text-secondary'}>
                                        {intl.formatMessage({
                                            id: 'sujetCheck.uploadOtherFileTitle',
                                            defaultMessage: 'Bild wurde hochgeladen',
                                        })}
                                    </h3>
                                    <p className={'small-text'}>
                                        {intl.formatMessage({
                                            id: 'sujetCheck.uploadOtherFileHelpText',
                                            defaultMessage: 'Eine andere Datei von Ihrem Computer auswählen oder fortfahren',
                                        })}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div
                        className={'modal-body d-flex flex-column justify-content-center align-items-center'}
                        style={{ minWidth: '600px' }}
                    >
                        {productImages && productImages.previews.length > 1 ? (
                            <Carousel
                                renderCenterLeftControls={({ previousSlide, currentSlide }) => {
                                    if (currentSlide !== 0) {
                                        return <SliderLeft onClick={previousSlide} />;
                                    } else {
                                        return null;
                                    }
                                }}
                                renderBottomCenterControls={null}
                                renderCenterRightControls={({ nextSlide, currentSlide, slideCount }) => {
                                    if (currentSlide !== slideCount - 1) {
                                        return <SliderRight onClick={nextSlide} />;
                                    } else {
                                        return null;
                                    }
                                }}
                            >
                                {productImages.previews.map((productImage, index) => (
                                    <img
                                        className={'caroussel-image'}
                                        src={productImage as string}
                                        alt="product image"
                                        key={`productImage-${index}`}
                                    />
                                ))}
                            </Carousel>
                        ) : (
                            <img src={productImages && productImages.previews[0]} alt="product image" />
                        )}
                    </div>
                );
            default:
                return <></>;
        }
    };

    return (
        <Modal id="sujetcheck-modal" isOpen={isModalOpen} transition={ModalTransition.NONE} onBackdropClick={handleClose}>
            <div className="modal-content sujetcheck-modal">
                <div className={'request-form__header'}>
                    {intl.formatMessage({ id: 'sujetCheck.title', defaultMessage: 'Sujetcheck' })}
                    <Button kind={ButtonKind.LINK} onClick={handleClose}>
                        <IconClose stroke="white" width="14" height="14" />
                    </Button>
                </div>
                {getStep(step)}
                <div id="sujetcheck-modal-error" className={'d-flex justify-content-center align-items-center mt-3'}>
                    {errors.map((error, index) => (
                        <div key={`error-${index} text-error`}>{error}</div>
                    ))}
                </div>
                <div className={'border-0 justify-content-center  modal-footer'}>
                    {step === 0 ? (
                        <Button kind={ButtonKind.PRIMARY} onClick={handleGetImages} disabled={!file} className="button__lg">
                            {intl.formatMessage({
                                id: 'sujetCheck.nextStep',
                                defaultMessage: 'Weiter zum nächsten schritt',
                            })}
                        </Button>
                    ) : (
                        <a
                            className={classNames('download-button button button__primary button__lg', {
                                button__disabled: !productImages || !productImages.download || isLoading,
                            })}
                            href={productImages && productImages.download}
                            download
                        >
                            <IconDownload />
                            {productImages && productImages.previews.length > 1
                                ? intl.formatMessage({
                                      id: isLoading ? 'sujetCheck.nextStep' : 'sujetCheck.downloadFiles',
                                      defaultMessage: 'Alle Bilder downloaden',
                                  })
                                : intl.formatMessage({
                                      id: isLoading ? 'sujetCheck.nextStep' : 'sujetCheck.downloadFile',
                                      defaultMessage: 'Hochauflösendes bild downloaden',
                                  })}
                        </a>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default SujetCheckPopupModal;
